import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import TableRow from "@mui/material/TableRow";
import TableFooter from "@mui/material/TableFooter";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import IconButton from "@mui/material/IconButton";
import PropTypes from "prop-types";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

function TablePaginationComponent({
  page,
  count,
  rowsPerPage,
  firstButtonClicked,
  lastButtonClicked = () => {},
  handleNextButtonClick = () => {},
  handleBackButtonClick = () => {},
  onPageDropdownChange = () => {},
}) {
  let menuItemsArr = [];

  for (let index = 0; index < Math.ceil(count / 5); index++) {
    menuItemsArr.push({ value: index + 1, label: index + 1 });
  }

  const pageStart = page < 1 ? 0 : (page - 1) * rowsPerPage + 1;
  let pageEnd = page * rowsPerPage;
  if (pageEnd > count) {
    pageEnd = count;
  }
  const boxStyle = {
    width: "auto",
    display: "block",
    border: "1px solid rgba(211,211,211, 0.25)",
    marginTop: ".6rem",
    borderRadius: "4px",
  };
  const boxStyle1 = {
    width: "auto",
    display: "block",
    borderRadius: "40px",
  };
  const boxContainer = {
    borderRadius: "0px",
    borderRight: "0.1px solid rgba(51, 46, 60, 0.1)",
    boxShadow: "none",
  };
  const boxItem = {
    backgroundColor: "#FCF7FF",
    borderRadius: "2px 0 0 2px",
    height: "4rem",
    boxShadow: "none",
    paddingTop: "1.1rem",
  };
  const boxIconButtons = {
    color: "#332E3C",
    fontSize: "1.3rem",
    display: "inline-block",
    width: "max-content",
  };
  const boxIconButtons2 = {
    marginRight: "1rem",
    fontSize: "1.3rem",
    color: "#332E3C",
  };
  const boxItem2 = {
    backgroundColor: "#FCF7FF",
    borderRadius: "0 2px 2px 0",
    height: "4rem",
    boxShadow: "none",
    fontSize: "1.3rem",
    lineHeight: "1.5rem",
    padding: ".55rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };
  return (
    <Box sx={boxStyle}>
      <Box sx={boxStyle1}>
        <Box
          sx={{
            flexGrow: 1,
          }}
        >
          <Grid container>
            <Grid item xs={12} sm={8} md={9} sx={boxContainer}>
              <Item sx={boxItem}>
                {page < 2 ? null : (
                  <span
                    onClick={firstButtonClicked}
                    style={{
                      color: "#332E3C",
                      cursor: "pointer",
                      fontSize: "1.3rem",
                    }}
                  >
                    First
                  </span>
                )}
                <IconButton
                  disabled={page < 2}
                  aria-label="previous page"
                  onClick={handleBackButtonClick}
                  size="large"
                  sx={{
                    padding: "0px",
                    color: "#3D4756",
                    opacity: page < 2 ? 0.3 : 1,
                    marginTop: "-.4rem",
                    fontSize: "1.2rem",
                  }}
                >
                  <KeyboardArrowLeft fontSize="large" />
                </IconButton>
                <span style={boxIconButtons}>
                  {`${pageStart} to ${pageEnd} of ${count}`}
                </span>
                <IconButton
                  disabled={page >= Math.ceil(count / rowsPerPage)}
                  aria-label="next page"
                  onClick={handleNextButtonClick}
                  sx={{
                    padding: "0px",
                    color: "#3D4756",
                    opacity: page >= Math.ceil(count / rowsPerPage) ? 0.3 : 1,
                    marginTop: "-.4rem",
                    fontSize: "1.2rem",
                  }}
                >
                  <KeyboardArrowRight fontSize="large" />
                </IconButton>
                {page >= Math.ceil(count / rowsPerPage) ? null : (
                  <span
                    onClick={lastButtonClicked}
                    style={{
                      color: "#332E3C",
                      cursor: "pointer",
                      fontSize: "1.3rem",
                    }}
                  >
                    Last
                  </span>
                )}
              </Item>
            </Grid>
            <Grid item xs={12} sm={4} md={3} sx={{}}>
              <Item sx={boxItem2}>
                <span style={boxIconButtons2}>Jump to page</span>
                <Box sx={{}}>
                  <select
                    style={{
                      border: "none",
                      outline: "none",
                      padding: ".5rem .8rem",
                      cursor: "pointer",
                    }}
                    onChange={onPageDropdownChange}
                    name="pageNo"
                    id="pageNo"
                    value={page}
                  >
                    {menuItemsArr.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </Box>
              </Item>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
}

TablePaginationComponent.propTypes = {
  lastButtonClicked: PropTypes.func,
  handleNextButtonClick: PropTypes.func,
  handleBackButtonClick: PropTypes.func,
  onPageDropdownChange: PropTypes.func,
};

export default TablePaginationComponent;
